/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An empirical relation, log₁₀(P) = A − B/(C + T), linking a solvent's vapor pressure and temperature using three fitted constants.`)
};

const es_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una relación empírica, log₁₀(P) = A − B/(C + T), que vincula la presión de vapor y la temperatura de un disolvente mediante tres constantes ajustadas.`)
};

const de_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine empirische Beziehung, log₁₀(P) = A − B/(C + T), die Dampfdruck und Temperatur eines Lösungsmittels über drei angepasste Konstanten verknüpft.`)
};

const nl_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een empirische relatie, log₁₀(P) = A − B/(C + T), die de dampspanning en temperatuur van een oplosmiddel koppelt met behulp van drie gefitte constanten.`)
};

const fr_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une relation empirique, log₁₀(P) = A − B/(C + T), reliant la pression de vapeur et la température d'un solvant à l'aide de trois constantes ajustées.`)
};

const it_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una relazione empirica, log₁₀(P) = A − B/(C + T), che collega tensione di vapore e temperatura di un solvente usando tre costanti calcolate per adattamento.`)
};

const pt_br2_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma relação empírica, log₁₀(P) = A − B/(C + T), que relaciona a pressão de vapor e a temperatura de um solvente usando três constantes ajustadas.`)
};

const pt_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma relação empírica, log₁₀(P) = A − B/(C + T), que liga a pressão de vapor e a temperatura de um solvente através de três constantes ajustadas.`)
};

const ja_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`log₁₀(P) = A − B/(C + T)という経験式で、3つのフィッティング定数を用いて溶媒の蒸気圧と温度を関連付けます。`)
};

const zh_bp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一种经验关系式 log₁₀(P) = A − B/(C + T)，通过三个拟合常数将溶剂的蒸气压与温度关联起来。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_faq_a2", locale)
	if (locale === "en") return en_bp_faq_a2(inputs)
	if (locale === "es") return es_bp_faq_a2(inputs)
	if (locale === "de") return de_bp_faq_a2(inputs)
	if (locale === "nl") return nl_bp_faq_a2(inputs)
	if (locale === "fr") return fr_bp_faq_a2(inputs)
	if (locale === "it") return it_bp_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_bp_faq_a2(inputs)
	if (locale === "pt") return pt_bp_faq_a2(inputs)
	if (locale === "ja") return ja_bp_faq_a2(inputs)
	return zh_bp_faq_a2(inputs)
};